export const PATHS = {
  path: '/:locale(no|en|uk)/reports',
  part: 'reports',
  Absence: {
    path: '/:locale(no|en|uk)/reports/absence',
    part: 'absence',
  },
};
